import React from "react";
import HelpfulLinkForm from "./HelpfulLinkForm";
import LoadMask from "../../../Utils/LoadMask";

export default class HelpfulLinkCreate extends React.Component {
    render() {
        const { create,loading,userInfo: { permission } } = this.props;

        return (
            <LoadMask loading={loading} dark blur>
                <div className="row">
                    <div className="col-12">
                        <HelpfulLinkForm onSubmit={create} />
                    </div>
                </div>
            </LoadMask>
        );
    }
}
